// extracted by css-extract-rspack-plugin
export default {"elevated":"OQvSKx2vdx0O6fYu"};